// Voucher Status

export const voucherStatusName = {
  ACTIVE: 'ACTIVE',
  FULLY_REDEEM: 'FULLY_REDEEM',
  CANCELED: 'CANCELED',
  EXPIRED: 'ACTIVE',
}

export const voucherStatus = {
  VOUCHER_ACTIVE: 1,
  VOUCHER_FULLY_REDEEM: 2,
  VOUCHER_CANCELED: 3,
  VOUCHER_EXPIRED: 4,
}

export const VOUCHER_STATUS = {
  [voucherStatus.VOUCHER_ACTIVE]: {
    name: voucherStatusName.ACTIVE,
    labelId: 'notification.voucherStatus.active',
    classes: 'voucherActive',
  },
  [voucherStatus.VOUCHER_FULLY_REDEEM]: {
    name: voucherStatusName.FULLY_REDEEM,
    labelId: 'notification.voucherStatus.fullyRedeem',
    classes: 'voucherFullyRedeem',
  },
  [voucherStatus.VOUCHER_CANCELED]: {
    name: voucherStatusName.CANCELED,
    labelId: 'notification.voucherStatus.canceled',
    classes: 'voucherCanceled',
  },
  [voucherStatus.VOUCHER_EXPIRED]: {
    name: voucherStatusName.EXPIRED,
    labelId: 'notification.voucherStatus.expired',
    classes: 'voucherExpired',
  },
}
